function initHideItems() {
    let finderItemHideIcon = document.getElementsByClassName('finder--item-hide-icon');
    for (var i = 0; i < finderItemHideIcon.length; i++) {
      finderItemHideIcon[i].addEventListener('click', function () {
        // this.parentNode.style.display = 'none';
        this.parentNode.classList.add('hide');
        initScrollArrows();
      });
    }

    let unhideItems = document.getElementById('unhide-items');

    unhideItems.addEventListener('click', function () {
      let activeGender = document.querySelector('.finder-nav-button.active').getAttribute('data-gender');
      const finderItemWrapper = document.querySelectorAll(
        '.finder--item-wrapper[data-product-gender="' + activeGender + '"]'
      );
      for (var i = 0; i < finderItemWrapper.length; i++) {
        finderItemWrapper[i].classList.remove('hide');
      }
      if (window.innerWidth < 768) {
        initMobileHoodieFinder();
      }
    });
  }

  initHideItems();

  function initStickyButtons() {
    const myDivs = document.querySelectorAll('.finder-view-button--wrapper');

    myDivs.forEach((myDiv) => {
      window.addEventListener('scroll', function () {
        if (window.scrollY >= 1600) {
          myDiv.classList.add('button--bottom');
        } else {
          myDiv.classList.remove('button--bottom');
        }
      });
    });
  }

  // document ready wrapper
  function initGenderButtons() {
    let buttons = document.querySelectorAll('.finder-nav-button');
    let items = document.querySelectorAll('.finder--item-wrapper');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        // Get the selected gender from the button's data attribute
        buttons.forEach(function (btn) {
          btn.classList.remove('active');
        });

        let selectedGender = this.getAttribute('data-gender');
        this.classList.add('active');
        // remove active from other button

        // Loop through all the items and show/hide them based on the gender
        items.forEach(function (item) {
          let productGender = item.getAttribute('data-product-gender');

          if (selectedGender === productGender || selectedGender === 'all') {
            item.classList.remove('hide');
          } else {
            item.classList.add('hide');
          }
        });

        // see if mobile and run mobile queries if needed
        if (window.innerWidth < 768) {
          initMobileHoodieFinder();
        }

        if (window.innerWidth > 767) {
          desktopRightScrollButton();
        }
      });

      if (window.innerWidth > 767) {
        initHideItems();
      }
    });
  }

  function initScrollArrows() {
    let wrapper_container = document.querySelector('.finder--wrapper');
    let arrow = document.querySelector('.finder--wrapper--arrow');
    let arrowLeft = document.querySelector('.finder--wrapper--arrow--left');

    if (wrapper_container.scrollWidth > wrapper_container.clientWidth) {
      arrow.classList.remove('hide');
      wrapper_container.style.overflowX = 'auto';
    } else {
      arrow.classList.add('hide');
      arrowLeft.classList.add('hide');
    }
  }

  function desktopRightScrollButton() {
    let div = document.querySelector('.finder--wrapper');
    let rect = div.getBoundingClientRect();
    let arrow = document.querySelector('.finder--wrapper--arrow');
    let arrowLeft = document.querySelector('.finder--wrapper--arrow--left');

    const container = document.querySelector('.finder--wrapper');
    console.warn('container: ' + container.scrollWidth);
    console.warn('clientWidth: ' + container.clientWidth);
    console.warn('scrollLeft: ' + container.scrllLeft);

    container.scrollTo({
      left: 0,
      behavior: 'smooth',
    });

    arrow.addEventListener('click', () => {
      arrow.classList.add('hide');

      container.scrollTo({
        left: container.scrollWidth - container.clientWidth,
        behavior: 'smooth',
      });
    });

    arrowLeft.addEventListener('click', () => {
      arrowLeft.classList.add('hide');

      container.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    });

    function checkScrollWidth() {
      if (container.scrollLeft === 0) {
        arrow.classList.remove('hide');
        arrowLeft.classList.add('hide');
      }

      if (container.scrollLeft === container.scrollWidth - container.clientWidth) {
        arrow.classList.add('hide');
        // arrowLeft.classList.remove('hide');
        arrowLeft.style.left = `${container.scrollLeft}px`;
      }

      if (container.scrollLeft > 0) {
        arrowLeft.classList.remove('hide');
        arrow.style.right = `-${container.scrollLeft}px`;
        arrowLeft.style.left = `${container.scrollLeft}px`;
      }
    }

    container.addEventListener('scroll', () => {
      checkScrollWidth();
    });

    window.addEventListener('load', () => {
      initScrollArrows();
    });

    window.addEventListener('resize', () => {
      initScrollArrows();
      checkScrollWidth();
    });

    initScrollArrows();
    checkScrollWidth();
  }

  function checkURL() {
    let url = window.location.href;
    if (url.includes('women')) {
      let button = document.querySelector('div[data-gender="women"]');
      button.click();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGenderButtons();
    let genderButtons = document.querySelectorAll('.finder-nav-button');
    genderButtons[0].click();
    checkURL();
    initHideItems();
    desktopRightScrollButton();
  });

  document.addEventListener('DOMContentLoaded', function (event) {
    if (window.innerWidth < 768) {
      initMobileHoodieFinder();
      initStickyButtons();
    }
  });

  function initMobileHoodieFinder() {
    let activeGender = document.querySelector('.finder-nav-button.active').getAttribute('data-gender');
    let itemWrappers = document.querySelectorAll('.finder--item-wrapper[data-product-gender="' + activeGender + '"]');

    let select1 = document.getElementById('select1');
    let select2 = document.getElementById('select2');
    while (select1.options.length > 0) {
      select1.remove(0);
    }

    while (select2.options.length > 0) {
      select2.remove(0);
    }
    itemWrappers.forEach((itemWrapper) => {
      let itemTitle = itemWrapper.querySelector('.item-title').textContent;

      let option1 = document.createElement('option');
      option1.value = itemTitle;
      option1.textContent = itemTitle;
      option1.dataset.columnHtml = itemWrapper.innerHTML;

      let option2 = document.createElement('option');
      option2.value = itemTitle;
      option2.textContent = itemTitle;
      option2.dataset.columnHtml = itemWrapper.innerHTML;

      select1.appendChild(option1);
      select2.appendChild(option2);
    });

    select1.value = itemWrappers[0].querySelector('.item-title').textContent;
    select2.value = itemWrappers[1].querySelector('.item-title').textContent;

    let leftColumnMobile = document.querySelector('.left-column-mobile');
    let rightColumnMobile = document.querySelector('.right-column-mobile');

    select1.addEventListener('change', () => {
      leftColumnMobile.innerHTML = select1.selectedOptions[0].dataset.columnHtml;
      initStickyButtons();
    });

    select2.addEventListener('change', () => {
      rightColumnMobile.innerHTML = select2.selectedOptions[0].dataset.columnHtml;
      initStickyButtons();
    });

    // Trigger the change event on the initial values to update the corresponding columns
    select1.dispatchEvent(new Event('change'));
    select2.dispatchEvent(new Event('change'));
  }